// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3SyAg","left":"StickyBox_left__3_DeD","right":"StickyBox_right__2MCLj"};